// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a10a3f92e9--wrapper--VERQ6","years":"a10a3f92e9--years--mqNM7"};